import {
  type AjaxError,
  isForbiddenError,
  isNotFoundError,
} from 'ember-ajax/errors';

// A 403 or 404 on a route's main request means the user can't open that
// hotel/market/destination, as opposed to a transient failure like a 500.
export default function isInaccessibleError(error: unknown): boolean {
  return (
    isForbiddenError(error as AjaxError) || isNotFoundError(error as AjaxError)
  );
}
